import { render, staticRenderFns } from "./Case2.vue?vue&type=template&id=0e9ce06a&scoped=true&"
import script from "./Case2.vue?vue&type=script&lang=js&"
export * from "./Case2.vue?vue&type=script&lang=js&"
import style0 from "./Case2.vue?vue&type=style&index=0&id=0e9ce06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ce06a",
  null
  
)

export default component.exports